import { createStore } from 'zustand-x';

// 1. Define your store state types
interface MobileAuthState {
  isUserAuthenticatedViaMobile: boolean;
  externalLaunchUrl: string;
  wasLaunchedFromExternalSource: boolean;
}

// 2. Create the store with strong typing
export const useMobileAuthStore = createStore('pushNotification')<MobileAuthState>(
  {
    isUserAuthenticatedViaMobile: false,
    externalLaunchUrl: '/app/home',
    wasLaunchedFromExternalSource: false,
  },
  { devtools: { enabled: true } }
).extendActions((set) => ({
  setExternalLaunchUrl: (url: string) => {
    set.state((state) => ({
      ...state,
      externalLaunchUrl: url,
    }));
  },
  setLaunchedFromExternal: (value: boolean) => {
    set.state((state) => ({
      ...state,
      wasLaunchedFromExternalSource: value,
    }));
  },
  authenticateUserViaMobile: () => {
    set.state((state) => ({
      ...state,
      isUserAuthenticatedViaMobile: true,
    }));
  },
  logoutUserFromMobile: () => {
    set.state((state) => ({
      ...state,
      isUserAuthenticatedViaMobile: false,
    }));
  },
}));
